// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2qh2g","requiredAsterisk":"Info_requiredAsterisk__rUBnz"};